import { Injectable } from '@angular/core';
import { Actor } from '@models/imported/SagaSchema/Actor';
import { CommunicationEquipment } from '@models/imported/SagaSchema/CommunicationEquipment';
import { Vehicle } from '@models/imported/SagaSchema/Vehicle';
import { MyEquipmentService } from '@techwan/ionic-core';
import { UnitEditor } from '../../schema/unit-editor';

@Injectable()
export class UnitEditorService {
  private _editor = new UnitEditor();
  public get editor(): UnitEditor {
    return this._editor;
  }

  constructor(private readonly myEquipment: MyEquipmentService) {
    const device = new CommunicationEquipment();
    device.Name = myEquipment.myDevice.Name;
    device.ObjGuid = myEquipment.myDevice.ObjGuid;
    this._editor.communicationEquipments.push(device);
  }

  saveTabActualState(obj: any, index: number) {
    index !== -1 ? (this._editor.tabsStates[index] = obj) : this._editor.tabsStates.push(obj);
  }

  addVehicle(item: Vehicle) {
    this._editor.vehicles.push(item);
  }

  removeVehicle(item: Vehicle) {
    const obj = this._editor.vehicles.find(i => i.ObjGuid === item.ObjGuid);
    this._editor.vehicles.splice(this._editor.vehicles.indexOf(obj), 1);
  }

  addActor(item: Actor) {
    this._editor.actors.push(item);
  }

  removeActor(item: Actor) {
    const obj = this._editor.actors.find(i => i.ObjGuid === item.ObjGuid);
    this._editor.actors.splice(this._editor.actors.indexOf(obj), 1);
  }

  addEquipment(item: CommunicationEquipment) {
    this._editor.communicationEquipments.push(item);
  }

  removeEquipment(item: CommunicationEquipment) {
    const obj = this._editor.communicationEquipments.find(i => i.ObjGuid === item.ObjGuid);
    this._editor.communicationEquipments.splice(this._editor.communicationEquipments.indexOf(obj), 1);
  }
}
